//ADD_DASHBOARD_WIDGET
export const ADD_DASHBOARD_WIDGET_REQUEST = "ADD_DASHBOARD_WIDGET_REQUEST";
export const ADD_DASHBOARD_WIDGET_SUCCESS = "ADD_DASHBOARD_WIDGET_SUCCESS";
export const ADD_DASHBOARD_WIDGET_FAIL = "ADD_DASHBOARD_WIDGET_FAIL";

//GET_DASHBOARD_WIDGET
export const GET_DASHBOARD_WIDGET_REQUEST = "GET_DASHBOARD_WIDGET_REQUEST";
export const GET_DASHBOARD_WIDGET_SUCCESS = "GET_DASHBOARD_WIDGET_SUCCESS";
export const GET_DASHBOARD_WIDGET_FAIL = "GET_DASHBOARD_WIDGET_FAIL";

//GET_ACTIVITY_OVERVIEW
export const GET_ACTIVITY_OVERVIEW_REQUEST = "GET_ACTIVITY_OVERVIEW_REQUEST";
export const GET_ACTIVITY_OVERVIEW_SUCCESS = "GET_ACTIVITY_OVERVIEW_SUCCESS";
export const GET_ACTIVITY_OVERVIEW_FAIL = "GET_ACTIVITY_OVERVIEW_FAIL";

//GET_DASHBOARD_RECRUITMENT
export const GET_DASHBOARD_RECRUITMENT_REQUEST =
  "GET_DASHBOARD_RECRUITMENT_REQUEST";
export const GET_DASHBOARD_RECRUITMENT_SUCCESS =
  "GET_DASHBOARD_RECRUITMENT_SUCCESS";
export const GET_DASHBOARD_RECRUITMENT_FAIL = "GET_DASHBOARD_RECRUITMENT_FAIL";
